import React from 'react';

/** 조합 관리 > 상세 > 포트폴리오 상세 > 현금흐름 */
const Cashflow = () => {
  return <>현금흐름</>;
};

export default Cashflow;
